import { TableCellProps } from '@mui/material';
import { ISelectionItem } from 'redux-store/api/selections';

export type CustomTableColumn = {
  id: number;
  name: string;
  role?: string;
  checked?: boolean;
  props?: TableCellProps;
  isHidden?: boolean;
  handleCheckboxChange?: (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => void;
};

export interface ISetRemindersFormValues {
  items: ISelectionItem[];
  projectId: number;
}

export enum PopperActionEnum {
  ADD = 'add item',
  EDIT = 'edit',
  DELETE = 'delete',
  CLONE = 'clone',
}
